export default __webpack_public_path__ + "static/media/cameraworld1.8240c7ef.PNG";